import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import './style.scss';

@observer
class MobileFormSelectField extends Component {
    @action handleSelectChange = ({target}) => {
        const {onChange, options} = this.props;
        const index = target.options.selectedIndex;
        onChange({value: options[index].value, label: target.value}, index, true);
    };

    render() {
        const {value, label, options, disabled, placeholder, className} = this.props;

        return (
            <div className={`select-mobile-container ${className || ''}`}>
                {label && <div className="select-mobile-title">{label}</div>}
                <div className="select-mobile-item">
                    <div className={`select-label ${value ? '' : 'placeholder'}`}>{value || placeholder}</div>
                    <select disabled={disabled} className="select-list" value={value} onChange={this.handleSelectChange}>
                        {options.map((item, index) => (
                            <option key={index} value={item.label}>{item.label}</option>
                        ))}
                    </select>
                </div>
            </div>
        );
    }
}

export default MobileFormSelectField;
